import { useSelector } from "react-redux";
import { RootState } from "../store";
import { useMemo } from "react";

export const useSelectUpdatedCompany = (id: string) => {
  const company = useSelector(
    (state: RootState) => state.company.updatedCompanies[id],
  );

  return useMemo(() => company, [company]);
};
